import React from 'react';
import PropTypes from 'prop-types';
import PortalModal from 'components/Modals/PortalModal';
import { Button } from '@agconnections/grow-ui';
import { customDateFormat } from 'helpers/dateFormat';
import './index.css';
import SuccessIcon from 'components/Icons/components/SuccessIcon';

const RetryLoadsModal = ({
  open,
  onClose,
  onDiscard,
  onRetry,
  taskData = null
}) => {
  const cropName = taskData?.otherFields?.cropName || '';
  const formattedDate = taskData?.createdAt
    ? customDateFormat(taskData.createdAt, 'MMM d, yyyy hh:mma')
    : '';

  const handleCancel = () => {
    onClose();
  };

  const handleDiscard = () => {
    onDiscard();
    onClose();
  };

  const handleRetry = () => {
    onRetry();
    onClose();
  };

  return (
    <PortalModal open={open} type="buttonless">
      <div
        className="flex flex-line w-full mt-5 justify-between"
        data-testid="retry-loads-modal"
      >
        <div className="flex mr-4">
          <SuccessIcon width={24} height={24} />
        </div>
        <div className="flex flex-col pr-10" style={{ flexGrow: 1 }}>
          <div className="flex flex-row justify-items-center pb-4">
            <h3 className="font-bold text-lg leading-6 text-gray-900 w-full">
              Try to save these loads again?
            </h3>
          </div>
          <div className="flex flex-col mb-4">
            We will re-process all the {cropName} loads that were created on{' '}
            {formattedDate}. You can check the Loads page for status updates.
          </div>

          <div className="mt-5 mb-5 flex flex-row justify-between w-full">
            <div className="-ml-10">
              <Button
                type="outline"
                id="cancel-button"
                onClick={handleCancel}
                data-testid="cancel-button"
              >
                Cancel
              </Button>
            </div>
            <div className="flex">
              <div className="mr-5">
                <button
                  type="button"
                  id="discard-button"
                  onClick={handleDiscard}
                  data-testid="discard-button"
                  className="btn-discard-load"
                >
                  Discard loads
                </button>
              </div>
              <div>
                <Button
                  type="primary"
                  id="save-button"
                  onClick={handleRetry}
                  data-testid="save-button"
                >
                  Save loads
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PortalModal>
  );
};

RetryLoadsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  taskData: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.string,
    cropSeasonId: PropTypes.string,
    actionType: PropTypes.string,
    otherFields: PropTypes.shape({
      cropName: PropTypes.string
    })
  })
};

export default RetryLoadsModal;
